require('../modules/web.timers');
require('../modules/web.immediate');
require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// /var/www/svea-ostosraha-fi/web/app/themes/opr-ostosraha/node_modules/@babel/polyfill/node_modules/core-js/web/index.js
// module id = 290
// module chunks = 0